import { render } from "./ConfirmTeamSuspendDialog.vue?vue&type=template&id=06e63001"
import script from "./ConfirmTeamSuspendDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmTeamSuspendDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__